// import React from "react";
// import { BrowserRouter, Routes, Route } from "react-router-dom";

// import LoginPage from "./pages/LoginPage";
// import QuizPage from "./pages/QuizPage";
// import ResultPage from "./pages/ResultPage";

// import AdminLogin from "./pages/admin/AdminLogin";
// import AdminDashboard from "./pages/admin/AdminDashboard";
// import AdminRegister from "./pages/admin/AdminRegister";
// import SuperAdminDashboard from "./pages/admin/SuperAdminDashboard";
// import SuperAdminLogin from "./pages/admin/SuperAdminLogin";
// export default function App() {
//   return (
//     <BrowserRouter>
//       <Routes>
//         {/* Student Side */}
//         <Route path="/" element={<LoginPage />} />
//         <Route path="/quiz" element={<QuizPage />} />
//         <Route path="/result" element={<ResultPage />} />

//         {/* Admin Side */}
//         <Route path="/admin-login" element={<AdminLogin />} />
//         <Route path="/admin" element={<AdminDashboard />} />
//         <Route path="/admin-register" element={<AdminRegister />} />
//         <Route path="/superadmin-login" element={<SuperAdminLogin />} />
//         <Route path="/superadmin" element={<SuperAdminDashboard />} />
//       </Routes>
//     </BrowserRouter>
//   );
// }
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import LandingPage from "./pages/LandingPage";

import LoginPage from "./pages/LoginPage";
import QuizPage from "./pages/QuizPage";
import ResultPage from "./pages/ResultPage";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminRegister from "./pages/admin/AdminRegister";
import SuperAdminDashboard from "./pages/admin/SuperAdminDashboard";
import SuperAdminLogin from "./pages/admin/SuperAdminLogin";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Landing Page (Main Home) */}
        <Route path="/" element={<LandingPage />} />

        {/* Student Side (Only after quiz link) */}
        <Route path="/start" element={<LoginPage />} />
        <Route path="/quiz" element={<QuizPage />} />
        <Route path="/result" element={<ResultPage />} />

        {/* Admin Side */}
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin-register" element={<AdminRegister />} />

        {/* Super Admin Side */}
        <Route path="/superadmin-login" element={<SuperAdminLogin />} />
        <Route path="/superadmin" element={<SuperAdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}
